import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "./Layout";
import { Modal } from "bootstrap";
import axios, { cookies } from "../../axios/axios";

const Profile = () => {
  const user = cookies.get("user");
  const loggedIn = user.user;

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const modalElement = document.getElementById("exampleModal");

    if (params.get("openModal") === "true" && modalElement) {
      const modal = new Modal(modalElement);
      modal.show();

      modalElement.addEventListener("hidden.bs.modal", () => {
        document.body.classList.remove("modal-open");
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) {
          backdrop.remove();
        }

        navigate("/user-dashboard", { replace: true });
      });
    }
  }, [location, navigate]);

  const handleLogout = async () => {
    try {
      const refreshToken = cookies.get("user")?.tokens?.refresh?.token;

      if (!refreshToken) {
        console.error("No refresh token found");
        return;
      }

      await axios.post("/auth/logout", { refreshToken });

      cookies.remove("user");
      window.location.href = "/login";
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <Layout>
      {/* Modal */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Profile Details
              </h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <table class="table">
                <tbody>
                  <tr>
                    <td>Id :</td>
                    <td>{loggedIn.id}</td>
                  </tr>
                  <tr>
                    <td>Name :</td>
                    <td>{loggedIn.fname}</td>
                  </tr>{" "}
                  <tr>
                    <td>Email :</td>
                    <td>{loggedIn.email}</td>
                  </tr>{" "}
                  <tr>
                    <td>Joined On :</td>
                    <td>{new Date(loggedIn.createdAt).toLocaleDateString()}</td>
                  </tr>
                </tbody>
              </table>
              <button
                onClick={handleLogout}
                className="btn px-2 py-2 bg_maincolor text-white  rounded"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
